import { getApiClient } from 'apiClient';
import { routes } from './routes';

type AbortUploadResponse = unknown;

export const abortUpload = async ({ mediaId }: { mediaId: string }) =>
  getApiClient().post<AbortUploadResponse>(routes.chunkedUpload.abort(mediaId));
